import { cn, getCloudinaryImgUrl } from '@finn/ui-utils';

import { GenericVehicleDetails } from '../../core/types';

type SlideProps = {
  image: string;
  index: number;
  totalImages: number;
};

const Slide = ({ image, index, totalImages }: SlideProps) => {
  return (
    <div className="relative w-[calc(100%-2rem)] flex-shrink-0 md:w-full">
      <div className="relative aspect-[16/10] w-full overflow-hidden rounded bg-snow">
        <img
          src={image}
          alt={image}
          className="size-full object-cover mix-blend-multiply"
        />
        <div className="absolute bottom-4 right-4 z-overlay rounded-md border border-solid border-pearl bg-white p-2 body-12-regular">
          {`${index + 1} / ${totalImages}`}
        </div>
      </div>
    </div>
  );
};

type Props = {
  vehicle: GenericVehicleDetails;
  className?: string;
};

export const VehicleImagesSlider = ({ vehicle, className }: Props) => {
  const pictures = vehicle.pictures.map((pic) => pic?.url).filter(Boolean);
  const imgOptions = {
    w: 720,
    dpr: 2,
    c: 'auto',
  };
  const imgUrls = pictures.map((pic) => getCloudinaryImgUrl(pic, imgOptions));

  return (
    <div className={cn('flex shrink-0 gap-4 overflow-x-auto', className)}>
      {imgUrls.map((image, index) => (
        <Slide
          key={index}
          image={image || ''}
          index={index}
          totalImages={imgUrls.length}
        />
      ))}
    </div>
  );
};
